export type AppEnvironment = "local" | "staging" | "production";

const normalizeAppEnvironment = (value?: string): AppEnvironment => {
    const normalizedValue = value?.trim().toLowerCase();

    if (normalizedValue === "production" || normalizedValue === "prod") {
        return "production";
    }

    if (normalizedValue === "staging" || normalizedValue === "stage" || normalizedValue === "preview" || normalizedValue === "beta") {
        return "staging";
    }

    return "local";
};

export const appEnvironment = normalizeAppEnvironment(process.env.REACT_APP_ENV);
export const isProductionApp = appEnvironment === "production";
export const isStagingApp = appEnvironment === "staging";
export const isLocalApp = appEnvironment === "local";

